import {signal} from "@preact/signals-react";

export const topBannersIsEmpty = signal(false)
export const topBannersHasLimit = signal(false)

export const resetTopBannersSignals = () => {
    topBannersIsEmpty.value = false
    topBannersHasLimit.value = false
}
